import React, {
  // Component,
  Dispatch,
  FC,
  SetStateAction,
  useState,
  useRef,
  useEffect,
  useCallback,
  // useCallback,
} from "react";
import { Modal, Fade, CircularProgress } from "@mui/material";
import "tinymce/skins/ui/oxide/skin.min.css";
import whiteCancel from "../common/img/white-cancel.svg";
import { useFetchNoticeBoardListByDepartmentIDQuery, useGetNoticeBoardListByDepartmentIDMutation } from "../../app/services/notice-board";
import Button from "../common/Button";
import { ExportIcon } from "../common/Icons";
import axios from "../../axios";
import { endpointUrl } from "../../app/services/api";
import { getAuthUser } from "../../app/services/dashboard";
interface IModalAnnounEditor {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  id: number;
  selected: any;
  setAckID: React.Dispatch<any>;
  departments: any;
  isFetchingDept?: boolean;
}

// interface IFilterStates {
//   tag: string;
// }
const NoticeBoardAcknowledgePopup: FC<IModalAnnounEditor> = ({
  isOpen,
  setIsOpen,
  id,
  selected,
  setAckID,
  departments,
  isFetchingDept
}) => {
  const [getNoticeDataByDepartmentID] = useGetNoticeBoardListByDepartmentIDMutation();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isExport, setIsExport] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);
  const [departmentList, setDepartmentList] = useState<any>([]);
  const [departmentID, setDepartmentID] = useState<number>(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if(isFetchingDept===false){
      if (departments) {
        setDepartmentList(departments)
        setDepartmentID(departments ? departments[0]?.department?.id : 0);
        const dept_id = departmentID !== 0 ? departmentID : departments ? departments[0]?.department?.id : 0;
        if (dept_id)
          getNoticeBoardListByDepartmentID(id, departmentID !== 0 ? departmentID : departments ? departments[0]?.department?.id : 0)
      }
    }
    
  }, [isOpen, departments, isFetchingDept]);
  useEffect(() => {
    if (departmentID) {
      getNoticeBoardListByDepartmentID(id, departmentID !== 0 ? departmentID : departments ? departments[0]?.department?.id : 0)
    }
  }, [departmentID])
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    isDown.current = true;
    startX.current = e.pageX - (scrollRef.current?.offsetLeft || 0);
    scrollLeft.current = scrollRef.current?.scrollLeft || 0;
  };

  const handleMouseLeave = () => {
    isDown.current = false;
  };

  const handleMouseUp = () => {
    isDown.current = false;
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDown.current || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = x - startX.current;
    scrollRef.current.scrollLeft = scrollLeft.current - walk;
  };
  const getNoticeBoardListByDepartmentID = (id: number, department_id: number) => {
    setIsFetching(true);
    const data = {
      id: id,
      department_id: department_id
    }
    getNoticeDataByDepartmentID(data).then((res: any) => {
      const sorted = [...res?.data?.noticeBoardEmpoyeesList].sort((a, b) => b.is_acknowledged - a.is_acknowledged);
      setEmployeeList(sorted);
      setIsFetching(false);
    })
  }
  var getUser = getAuthUser();
  const exportNoticeBoardData = (id:number) => {
    setIsExport(true);
    axios({
      url:
        endpointUrl +
        `exportnoticeacknowlegedEmployeeListByDepartment/${id}`,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${getUser.token}`,
      },
    })
      .then((response) => {
        setIsExport(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "notice_board.csv"
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((error: any) => {
      });
  };

  const read_count = departments?.reduce((acc: any, item: any) => acc + item.acknowledged, 0);
  return (
    <Modal
      open={isOpen}
      style={{
        background: "rgb(0 0 0 / 0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setIsOpen(false);
          setAckID('')
          setDepartmentID(0);
          setDepartmentList([]);
          setEmployeeList([]);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEnforceFocus={true}
    >
      <Fade in={isOpen} timeout={500}>
        <div className="modalContent w-full xl:max-w-[1200px] max-w-[90%] annoucement-modalw-full px-5">
          <div className="">
            <div
              id="modal-modal-title"
              className="bg-vorpblue relative flex justify-between py-6 sm:px-10 px-5 rounded-t-xl"
            >
              <h3 className="text-18 font-primary font-semibold text-white">
                Notice Board Acknowledge List ({read_count??'' + '/' + selected?.employees?.length})
              </h3>
              <button
                className="flex items-center justify-center"
                onClick={() => {
                  setIsOpen(false);
                  setAckID('')
                }}
              >
                <img src={whiteCancel} alt="close modal icon" />
              </button>
            </div>
            <div
              id="modal-modal-description"
              className="pb-[26px] px-5 bg-white rounded-b-xl  overflow-y-auto max-h-[70vh] h-full min-h-[200px]"
            >
              {(isFetchingDept === true) ? <div className="flex items-center justify-center min-h-[200px]">
                <CircularProgress />
              </div> :
                <div className="pt-[26px] min-h-[300px] flex flex-col justify-between">
                  <div>
                  <div className="flex justify-end mb-3">
                  <Button
                      label={
                        <span className="flex items-center">
                          <ExportIcon className="mr-[5px]" /> Export
                        </span>
                      }
                      onClick={() => {
                        exportNoticeBoardData(id)
                      }}
                      type="button"
                      variant="no-outline"
                      customClass={`my-1 bg-vorpmyanmar border-vorpmyanmar hover:bg-vorpblue hover:text-white transition-all duration-300 text-vorpblue xs:text-[12px] leading-[18px] font-medium py-1 px-[6px] sm:mr-[10px] mr-[5px]
                      ${isExport===true?'opacity-50 pointer-events-none':''}`}
                      size="base"
                    />
                  </div>
                  <div>
                    <div ref={scrollRef}
                      onMouseDown={handleMouseDown}
                      onMouseLeave={handleMouseLeave}
                      onMouseUp={handleMouseUp}
                      onMouseMove={handleMouseMove}
                      className="flex overflow-x-auto border-b border-b-[#E2E2E2] custom-scroll-x">
                      {departmentList?.map((dept: any, key: number) => {
                        return <button onClick={() => {
                          setDepartmentID(dept?.department.id);
                          getNoticeBoardListByDepartmentID(id, dept?.department.id)
                        }} className={`md:text-16 text-14 pr-8 whitespace-nowrap pb-3 text-black relative after:w-full after:h-[1px] after:bg-[#9E3039] after:absolute after:bottom-0 after:left-0 after:opacity-0
                       ${departmentID === dept?.department?.id ? 'after:opacity-100 font-medium' : 'opacity-50 font-medium '}`} key={key}>{dept?.department?.name_en} {dept?.acknowledged}/{dept?.total_employees}</button>
                      })}

                    </div>
                    {isFetching === true ? <CircularProgress /> : <ul className="grid sm:grid-cols-3 xs:grid-cols-2 grid-cols-1 gap-3 max-h-[50vh] overflow-auto custom_scrollbar_popup mt-5">
                      {employeeList?.map((emp: any, key: number) => {
                        return <li key={key} className={`md:text-16 text-14 px-3 py-2 rounded-lg mb-1 w-full ${emp.is_acknowledged === true ? 'bg-[#D7FFD7]' : 'bg-[#FFE5E5]'}`}>
                          {emp.name_en}
                        </li>
                      })}
                    </ul>}
                  </div>
                  </div>
                  <div className="flex justify-end mt-5">
                    <div className="md:inline-flex block md:w-auto w-full items-center px-5 py-3 rounded-lg justify-end border border-[#E2E2E2] ml-auto">
                      <div className="flex items-center md:mr-8 md:mb-0 mb-2">
                        <span className="inline-block w-5 h-5 aspect-square bg-[#FFE5E5] rounded-full mr-3"></span>
                        <span className="text-14 font-normal text-black leading-normal">Pending</span>
                      </div>
                      <div className="flex items-center">
                        <span className="inline-block w-5 h-5 aspect-square bg-[#D7FFD7] rounded-full mr-3"></span>
                        <span className="text-14 font-normal text-black leading-normal">Acknowledged</span>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default NoticeBoardAcknowledgePopup;
